module.exports = __webpack_public_path__ + "img/ic_apolices_azul.d06b8fc3.svg";